import { StoreService } from '../core/store.service';
import { BaseStore, Catalog, SessionItem, eItem, Category, Product } from '../shared';
import { PathName } from '../shared/path.model';

export class BaseFormation extends BaseStore {

  constructor(protected store: StoreService) {
    super(store);
  }

  protected setCatalog(c: Catalog): void {
    this.store.PathItem.SetPathItem(PathName.CATALOG, c.Ident, c);

    let item: SessionItem|null = super.getSession(eItem.CATALOG);
    if (!item)
      item = new SessionItem(eItem.CATALOG);

    item.id = c.Ident;
    item.desc = c.Name_CTL;
    item.jsData = JSON.stringify(c);
    this.store.AddDataSession(item);
  }

  protected setCategory(c: Category): void {
    this.store.PathItem.SetPathItem(PathName.CATEGORY, c.Ident, c);

    let item: SessionItem | null = this.getSession(eItem.CATEGORY);
    if (!item)
      item = new SessionItem(eItem.CATEGORY);

    item.id = c.Ident;
    item.desc = c.Nom__CAT;
    item.jsData = JSON.stringify(c);
    this.store.AddDataSession(item);
    // TRACE ERROR (do not remove this line)
    if (!c.User_CAT || c.User_CAT === '') this.store.traceData(`--CATEGORY IDENT ${c.Ident} ${c.Nom__CAT} HAS NOT A SPECIFIED USER (User_CAT)`);
  }

  protected setProduct(c: Product): void {
    let item: SessionItem | null = this.getSession(eItem.PRODUCT);
    if (!item)
      item = new SessionItem(eItem.PRODUCT);

    item.id = c.Ident;
    item.code = c.Code_PRO;
    item.desc = c.DescrPRO;
    item.jsData = JSON.stringify(c);
    item.responsable = c.Responsable;
    this.store.AddDataSession(item);
    // TRACE ERROR (do not remove this line)
    if (!c.Responsable) this.store.traceData(`--PRODUCT IDENT ${c.Ident} ${c.DescrPRO} HAS NOT A SPECIFIED RESPONSABLE (from category)`);
  }
}
